import { StandardEvents } from '@shopify/events';

function filterGallery(dataEl, variantId) {
  let data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  const gallery = dataEl.closest('media-gallery');
  if (!gallery) return;

  const filenames = data.variants[String(variantId)];
  if (!filenames || filenames.length === 0) return;

  gallery.querySelectorAll('.product-media-container').forEach((slide) => {
    const img = slide.querySelector('img');
    if (!img) return;
    const src = img.getAttribute('src') || img.getAttribute('data-src') || '';
    const visible = filenames.some((f) => src.includes(f));
    slide.style.setProperty('display', visible ? '' : 'none', 'important');
  });
}

function filterAllGalleries(variantId) {
  document.querySelectorAll('[id^="variant-gallery-data-"]').forEach((dataEl) => {
    filterGallery(dataEl, variantId);
  });
}

function handleProductSelect(event) {
  if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

  event.promise
    ?.then(({ detail }) => {
      const variantId = detail?.resource?.id;
      if (!variantId) return;
      filterAllGalleries(variantId);
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[variant-gallery-filter] Event promise rejected:', error);
    });
}

function init() {
  // Re-applies on load using whichever variant is already selected, since the
  // theme swaps in a brand-new <media-gallery> element (fetched fresh, unfiltered)
  // on every color/variant change rather than mutating the existing one. Listening
  // at the document level means this always runs after that swap has happened,
  // so it re-queries and filters the gallery that's actually live in the DOM.
  document.addEventListener(StandardEvents.productSelect, handleProductSelect);

  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get('variant') || document.querySelector('input[name="id"]')?.value;
  if (variantId) filterAllGalleries(variantId);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
